<div class="modal-header-modern">
  <div class="modal-header-icon icon-blue">
    <i class="material-icons">alarm</i>
  </div>
  <div>
    <h4 class="modal-title-modern">Cadastro de Lembrete</h4>
    <p class="modal-subtitle-modern">Preencha os dados do lembrete</p>
  </div>
  <button type="button" class="modal-close-btn" aria-label="Close" (click)="cancelar()">
    <i class="material-icons">close</i>
  </button>
</div>
<div class="modal-body">
  <div class="container">
    <form [formGroup]="lembreteForm">
      <div class="row">
        <mat-form-field class="col-xl-8" appearance="outline">
          <mat-label>Título</mat-label>
          <input matInput formControlName="titulo" required placeholder="Título do lembrete" maxlength="300" />
          <mat-error *ngIf="lembreteForm.controls.titulo.hasError('required')">
            Campo Obrigatório!
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-xl-4" appearance="outline">
          <mat-label>Data do Lembrete</mat-label>
          <input matInput type="date" formControlName="dataLembrete" required />
          <mat-error *ngIf="lembreteForm.controls.dataLembrete.hasError('required')">
            Campo Obrigatório!
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field class="col-xl-12" appearance="outline">
          <mat-label>Cliente (opcional)</mat-label>
          <input matInput type="text" placeholder="Pesquise pelo nome do cliente"
            [formControl]="termoBuscaCliente" [matAutocomplete]="autoCliente" />
          <mat-autocomplete #autoCliente="matAutocomplete" (optionSelected)="selecionarCliente($event)"
            [displayWith]="nomeExibicaoAutocomplete">
            <mat-option *ngFor="let cliente of clientesPesquisados | async" [value]="cliente">
              {{cliente.nome}}
            </mat-option>
          </mat-autocomplete>
          <mat-hint *ngIf="termoBuscaCliente.value && !lembreteForm.value.clienteId" style="color: #94a3b8;">
            Selecione um cliente da lista ou deixe em branco
          </mat-hint>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field class="col-xl-12" appearance="outline">
          <mat-label>Descrição</mat-label>
          <textarea matInput formControlName="descricao" rows="3" placeholder="Descrição do lembrete" maxlength="1000"></textarea>
        </mat-form-field>
      </div>

      <div class="row" style="align-items: center; margin-bottom: 8px;">
        <div class="col-xl-4">
          <mat-checkbox formControlName="recorrente" color="primary">
            Lembrete recorrente
          </mat-checkbox>
        </div>
        <mat-form-field class="col-xl-4" appearance="outline" *ngIf="lembreteForm.value.recorrente">
          <mat-label>Intervalo (dias)</mat-label>
          <input matInput type="number" formControlName="intervaloEmDias" min="1" placeholder="Ex: 30" />
          <mat-hint>Repetir a cada X dias</mat-hint>
        </mat-form-field>
      </div>

      <ngx-loading [show]="loading"></ngx-loading>
    </form>
  </div>
</div>

<div class="modal-footer-modern">
  <button type="button" class="btn-modern btn-modern-outline" (click)="cancelar()">
    <i class="material-icons">close</i> Cancelar
  </button>
  <button type="button" class="btn-modern btn-modern-success" (click)="confirmar()">
    <i class="material-icons">check</i> Confirmar
  </button>
</div>
